/**
 * The AvatarNameMobile component displays user's avatar, name, username and tagline.
 * @param {Object} profile - the user's profile
 */

import React, { useState } from 'react';
import classNames from 'classnames';

import Avatar from './Avatar.component';
import type { UserProfile } from '../types';

export default function AvatarNameMobile({
  profile,
  isSelf = false,
}: {
  profile: UserProfile & { displayUsername?: string };
  isSelf?: boolean;
}) {
  const [isBiggerAvatar, setIsBiggerAvatar] = useState(false);
  const showPhotoEditLink =
    isSelf && (!profile.avatarUploaded || profile.avatarSource === 'none');

  return (
    <div className="text-center visible-xs-block" role="dialog">
      {/* Avatar */}
      <a
        href={showPhotoEditLink ? '/profile/edit/photo' : undefined}
        onClick={
          showPhotoEditLink
            ? undefined
            : () => setIsBiggerAvatar(prevState => !prevState)
        }
        className={classNames('visible-xs-block', 'avatar-circle', {
          'profile-avatar-lg': isBiggerAvatar,
        })}
        aria-label={showPhotoEditLink ? 'Edit profile photo' : undefined}
        aria-hidden={showPhotoEditLink ? undefined : true}
      >
        <Avatar user={profile} size={512} link={false} />
      </a>

      {/* Name */}
      {profile.displayName && (
        <h2 className="profile-name">{profile.displayName}</h2>
      )}

      <br />

      {/* Username */}
      <h4 className="profile-username">
        @{profile.displayUsername || profile.username}
      </h4>

      <br />

      {/* Tagline */}
      {profile.tagline && <p className="profile-tagline">{profile.tagline}</p>}
    </div>
  );
}
